import React, {useState} from 'react';
import {Folha} from '../../componentes/folha/folha';
import {Row, Col, Divider, Button, Input,Form, Modal, Typography} from 'antd';
import {AutoCompleteVendasWidget, AutoCompletePessoasWidget, Impressao, Dinheiro} from '@contentsys/contentsys-react-components';
import {useAxios} from '../../hooks/use-axios';
import {ItensDevolucao} from './componentes/itens-devolucao';
import {TotalBar, Label, ValuesList, Valor, ActionsList} from './componentes/total-bar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-duotone-svg-icons';
import moment from 'moment';

import {useDevolucao} from '../../hooks/use-devolucao';
import { LayoutImpressaoDevolucao } from '../componentes/layout-impressao-devolucao';

const FormularioDevolucao = () => {

    const {getApiEmitirNotas} = useAxios();

    const [creditoTotal, setCreditoTotal] = useState(0);

    const {salvaDevolucao} = useDevolucao(getApiEmitirNotas)

    const [salvando, setSalvando] = useState(false);

    const [devolucaoGerada, setDevolucaoGerada] = useState();

    const [vendaSelecionada, setVendaSelecionada] = useState(null);
    const [mostraTotal, setMostraTotal] = useState(false);
    const [openImpressaoDevolucao, setOpenImpressaoDevolucao] = useState();

    const [form] = Form.useForm();

    const onSelect = (obj) => {
        
        setVendaSelecionada(obj);
        if(obj == null){
            onChangeCredito([]);
        }
    }

    const onChangeCredito = (itens) =>  {
        calculaTotalCreditos(itens);
    }

    const calculaTotalCreditos = itens => {
        const totalCredito = itens.reduce((inicio, atual) => {
            return inicio + (atual.credito || 0);
        },0);

        setCreditoTotal(totalCredito);
        
        setMostraTotal(totalCredito > 0);

        form.setFieldsValue({
            valorTotalDevolvido: totalCredito
        })
        
    }

    let cliente = null;

    const registraDevolucao = async() => {
        setSalvando(true);
        const data = await salvaDevolucao(form);
        setSalvando(false);
        
        if(data.err || data.error){
            Modal.error({
                title: "Houve um problema ao salvar a devolução",
                content: "Tente novamente mais tarde ou contacte o suporte."
            })
        } else {
            setDevolucaoGerada(data);
            const habilitaPopup = false;
            
            try{
                openImpressaoDevolucao.send();
            } catch(e){
                console.log(e);
                habilitaPopup = true;
            }

            let content = "Muito bem. Devolução salva com sucesso.";
            if(habilitaPopup){
                content += "\n Habilite o popup para ver a impressão após salvar a devolução."
            }

            Modal.success({
                title: "Salvo com sucesso",
                content: content
            });



        }
        
        onSelect(null);
        form.resetFields();
        
        
    }


    if(mostraTotal){
        cliente = <>
        
                    {/* <Row style={{marginTop:"24px"}} >
                        <Col span={24}>
                            <Form.Item
                                
                                id="cliente"
                                name="cliente"
                                label="Destinatário para NF-e Devolução"
                            >
                                <AutoCompletePessoasWidget 
                                    getApi={getApiEmitirNotas}                 
                                    tipoPessoa="CLIENTE"
                                    comBotaoAdicionar={true}
                                    style={{
                                        width: '100%'
                                    }}
                                    autoCompleteProps={{
                                        style: {
                                            width: 'calc(100% - 50px)'
                                        }
                                    }}
                                    inputProps={{
                                        size: 'large',
                                        style: {
                                            width: '100%'
                                        }
                                    }}   
                                ></AutoCompletePessoasWidget>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider></Divider> */}

                    <Form.Item
                            
                            id="obs"
                            name="obs"
                            label="Observações"
                        >
                        <Input.TextArea rows={6}></Input.TextArea>
                    
                    </Form.Item>
        </>;
    }
    return(<Folha>

        <h1>Nova Devolucao</h1>

        <Form layout="vertical" form={form}> 

            <Row style={{marginTop: '20px'}}>
                <Col>
                    <Form.Item label="Venda/Pedido" id="venda" name="venda">

                        <AutoCompleteVendasWidget
                                getApi={getApiEmitirNotas}
                                onSelect={onSelect}
                            ></AutoCompleteVendasWidget>  
                    </Form.Item>
                </Col>
                

            </Row>
            <Divider></Divider>
            <Row>
                <Col span={24}>
                    <Form.Item id="itens" name="itens">
                        <ItensDevolucao vendaSelecionada={vendaSelecionada} onChangeCredito={onChangeCredito}></ItensDevolucao>
                    </Form.Item>
                </Col>
            </Row>

            {cliente}
            

            <TotalBar visible={mostraTotal}>
                <ValuesList>
                    <Label>Total em Cŕeditos</Label>
                    <Valor tipo="dinheiro">{creditoTotal}</Valor>
                </ValuesList>
                <ActionsList>
                    
                    <Button onClick={registraDevolucao} loading={salvando} size="large" type="primary" icon={<FontAwesomeIcon icon={faCheck}></FontAwesomeIcon>}>Confirmar</Button>
                </ActionsList>
            </TotalBar>
        </Form>

        <LayoutImpressaoDevolucao setOpenEvent={setOpenImpressaoDevolucao} devolucao={devolucaoGerada}></LayoutImpressaoDevolucao>

      
        
    </Folha>
    );
}

export {FormularioDevolucao};